import {
  getSiteStatus,
  getSiteName,
  getSiteHostName,
  getSiteCampaignId,
  getSitePromotedSite,
  getSiteDefaultLang,
  getSiteTemplateId,
  getSiteAgeVerify,
  getSiteTitle,
  getSiteKeywords,
  getSiteDescription,
} from './site';


export const getCurrentSiteId = state => {
  const { currentSiteId } = state.site;
  return currentSiteId ? parseInt(currentSiteId, 10) : null;
};

export const getCurrentSiteStatus = state => getSiteStatus(state, getCurrentSiteId(state));
export const getCurrentSiteName = state => getSiteName(state, getCurrentSiteId(state));
export const getCurrentSiteHostName = state => getSiteHostName(state, getCurrentSiteId(state));
export const getCurrentSiteCampaignId = state => getSiteCampaignId(state, getCurrentSiteId(state));
export const getCurrentSitePromotedSite = state => (
  getSitePromotedSite(state, getCurrentSiteId(state))
);
export const getCurrentSiteDefaultLang = state => (
  getSiteDefaultLang(state, getCurrentSiteId(state))
);
export const getCurrentSiteTemplateId = state => getSiteTemplateId(state, getCurrentSiteId(state));
export const getCurrentSiteAgeVerify = state => getSiteAgeVerify(state, getCurrentSiteId(state));
export const getCurrentSiteTitle = state => getSiteTitle(state, getCurrentSiteId(state));
export const getCurrentSiteKeywords = state => getSiteKeywords(state, getCurrentSiteId(state));
export const getCurrentSiteDescription = state => (
  getSiteDescription(state, getCurrentSiteId(state))
);
